import { WHITE } from '@styles/colors'
import styled from 'styled-components'
import { safeAreaInset } from '@lib/telegram'

export const OnBoardingContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  background-color: ${WHITE};
  margin: 0;
  gap: 24px;
`

export const CarouselContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
  flex: 1; /* Take up available space */
  position: relative; /* For absolute positioning of children if needed */
`

export const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
  background-color: ${WHITE};
  padding-bottom: ${safeAreaInset().bottom || 8}px;
`